import { render, staticRenderFns } from "./TreeFolderIcon.vue?vue&type=template&id=e943407a"
import script from "./TreeFolderIcon.vue?vue&type=script&lang=js"
export * from "./TreeFolderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports